import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

function TeamPreviewSwiper() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/team`)
      .then(res => setTeam(res.data))
      .catch(err => console.error(err));
  }, []);

  return (
    <div className="py-12 px-4 md:px-20 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold font-ec text-textPrimary mb-8">專業團隊</h2>
        <Swiper
          modules={[Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {team.map((member, idx) => (
            <SwiperSlide key={idx}>
              <div className="p-6 bg-background rounded-xl shadow text-center border" style={{ borderColor: '#D8C4B6' }}>
                <img src={member.photoUrl} alt={member.name} className="w-32 h-32 mx-auto rounded-full object-cover object-top mb-4" />
                <h3 className="text-lg font-ec font-bold text-textPrimary">{member.name} {member.title}</h3>
                <p className="text-sm font-ec text-textSecondary">{member.education?.[0]}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
export default TeamPreviewSwiper;